import '/home/runner/work/tswm-components-library/tswm-components-library/node_modules/@storybook/addon-knobs/dist/register.js';